<template>
  <div class="main">
    <div class="new-user" v-if="isNewUser">
      <div class="new-user-box">
        <p>抱歉，您是注册老用户</p>
        <p>无法为好友助力哦~</p>
      </div>
    </div>
    <div class="join-group" v-if="successFlag">
      <div class="join-group-box">
        <img
          src="../images/close-icon.svg"
          alt=""
          @click="handleShow"
          class="close-img"
        />
        <div>
          <p>您已成功助力！</p>
          <p>邀您入群享福利</p>
        </div>
        <img src="../images/invite/join-group.png" alt="" />
        <a href="#/">我也要免费领码</a>
      </div>
    </div>
    <div class="banner">
      <img src="../images/invite/banner.jpg" alt="" />
    </div>
    <div class="banner-mobile">
      <img src="../images/invite/banner-mobile.jpg" alt="" />
    </div>
    <div class="wrapper">
      <img class="bg1" src="../images/bg1.png" alt="" />
      <img class="bg2" src="../images/bg2.png" alt="" />
      <img class="bg3" src="../images/bg3.png" alt="" />
      <img class="bg4" src="../images/bg4.png" alt="" />
      <img class="bg5" src="../images/bg5.png" alt="" />
      <img class="ball1" src="../images/ball1.png" alt="" />
      <img class="ball2" src="../images/ball1.png" alt="" />
      <!-- 登录注册 -->
      <div class="login-wrap">
        <div class="login" v-if="!successFlag">
          <p class="title">
            好友<span>{{ this.friendName }}</span
            >邀您助力，免费领增值版激活码
          </p>
          <div class="loginForm-box">
            <div class="phoneNum-verify-wrap">
              <input
                type="text"
                class="phone-number"
                placeholder="输入手机号码"
                v-model="phoneNumber"
              />
              <p class="veriPhone" v-show="showPhoneTip">
                {{ this.veriPhone }}
              </p>
            </div>
            <div class="img-verify-wrap">
              <input
                type="text"
                placeholder="输入图形验证码"
                class="imgCodeIpt"
                v-model="imgCodeNumber"
              />
              <img :src="randomImg" id="img-code" @click="changeImgCode" />
              <p class="veriImg" v-show="showImgTip">{{ this.veriImg }}</p>
            </div>
            <div class="phone-verify-wrap">
              <input
                type="text"
                class="veri-code"
                placeholder="输入手机验证码"
                v-model="codeNumber"
                maxlength="6"
              />
              <p class="veriCode" v-show="showCodeTip">{{ this.veriCode }}</p>
              <!-- <div class="btn-message">获取短信验证码</div> -->
              <div v-if="!isCounting" class="btn-message" @click="sendCode">
                {{ this.veriBtn }}
              </div>
              <div v-if="isCounting" class="veri-btn-counting">
                {{ this.veriBtn }}
              </div>
            </div>
            <div class="btn-wrap"></div>
            <div class="next-btn" @click="handleNext">为好友助力</div>
          </div>
        </div>
      </div>
      <!-- 激活成功 -->
      <div class="success" v-if="successFlag">
        <p class="title">
          好友<span>{{ this.friendName }}</span
          >邀您助力，免费领增值版激活码
        </p>
        <div class="successForm-box">
          <div class="info">
            <p>您已成功助力好友！</p>
            <p>完成激活，可帮助好友加速完成任务</p>
          </div>
          <a
            class="btn"
            href="https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/index"
            target="_blank"
            onclick="gtag('event', '前往激活', {'event_category' : '邀友活动', 'event_label' : 'click1'});"
            >前往激活</a
          >
          <!-- <div class="btn">
            <a
              class="active-btn"
              href="https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/index"
              target="_blank"
              onclick="gtag('event', '前往激活', {'event_category' : '邀友活动', 'event_label' : 'click1'});"
              >前往激活</a
            >
          </div> -->
          <a href="https://ai.arcsoft.com.cn/manual/docs#/220" target="_blank"
            >如何激活?</a
          >
        </div>
      </div>
      <div class="three-steps">
        <img class="title3" src="../images/invite/title3.png" alt="" />
        <div class="three-steps-content">
          <div class="three-steps-item">
            <img src="../images/icon1.png" alt="" />
            <p>点击按键</p>
            <p>复制链接后分享给业内好友</p>
          </div>
          <div class="three-steps-item">
            <img src="../images/icon2.png" alt="" />
            <p>好友通过邀请</p>
            <p>成功注册或注册激活</p>
          </div>
          <div class="three-steps-item">
            <img src="../images/icon3.png" alt="" />
            <p>完成邀友任务</p>
            <p>即可获赠增值版激活码</p>
          </div>
        </div>
      </div>
      <div class="three-steps-mobile">
        <div class="title">
          <p>免费领码 仅需三步</p>
          <p></p>
          <p></p>
        </div>
        <div class="three-steps-mobile-content">
          <ul>
            <li>
              <img src="../images/mobile/icon1.png" alt="" />
              <p>点击按键复制链接后分享给业内好友</p>
            </li>
            <li>
              <img src="../images/mobile/icon2.png" alt="" />
              <p>好友通过邀请成功注册或注册激活</p>
            </li>
            <li>
              <img src="../images/mobile/icon3.png" alt="" />
              <p>完成邀友任务即可获赠增值版激活码</p>
            </li>
          </ul>
        </div>
      </div>
      <a
        class="get-code"
        href="#/"
        onclick="gtag('event', '我也要领码', {'event_category' : '邀友活动', 'event_label' : 'click1'});"
        >我也要领码</a
      >
      <div class="qrcode">
        <p>邀您行业交流·礼包欢送</p>
        <img src="../images/invite/qrcode.png" alt="" />
        <p class="dd">扫码入群，与行业专家交流、参与群内抽奖活动</p>
        <div class="tt">
          <p>扫码入群</p>
          <p>与行业专家交流、参与群内抽奖活动</p>
        </div>
      </div>
      <div class="activity">
        <p class="activity-heading">活动细则</p>
        <div class="rule first">
          <img src="../images/rule1.png" alt="" />
          <p class="title">活动时间</p>
          <p>活动截止到2024年12月31日</p>
        </div>
        <div class="rule second">
          <img src="../images/rule2.png" alt="" />
          <p class="title">参与人群</p>
          <p>平台内所有用户</p>
        </div>
        <div class="rule third">
          <img src="../images/rule3.png" alt="" />
          <p class="title">活动内容</p>
        </div>
        <div class="content">
          <p>
            活动期间，新老用户加入行业交流群，即可参与社群内抽奖活动，奖品为实物奖品（价值80元）；
            中奖后分享至朋友圈，并截图联系虹助手领取。
          </p>
        </div>
        <div class="rule fourth">
          <img src="../images/rule4.png" alt="" />
          <p class="title">实物奖品发送</p>
        </div>
        <div class="deliver">
          <p class="deliver-title">
            <span>1. </span>因奖品有限，在社群抽奖活动中，用户仅限获得1次奖品，
            即用户中奖后将无法重复参与本次抽奖活动；
          </p>
          <p class="deliver-title">
            <span>2. </span>获得实物奖品的用户请及时联系虹助手，
            虹助手将与您核实地址并在取得联系后15个工作日内寄送奖品。
          </p>
        </div>
        <div class="tips">
          <p class="tips-title">注意事项</p>
          <p>
            1.
            对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖的用户，
            虹软视觉开放平台有权取消其获奖资格或其因参加活动所获权益；
          </p>
          <p>2. 虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。</p>
        </div>
      </div>
      <div class="activity-mobile">
        <p class="activity-mobile-heading">活动细则</p>
        <div class="rule first">
          <img src="../images/rule1.png" alt="" />
          <p class="title">活动时间</p>
        </div>
        <p>活动截止到2024年12月31日</p>
        <div class="rule second">
          <img src="../images/rule2.png" alt="" />
          <p class="title">参与人群</p>
        </div>
        <p>平台内所有用户</p>
        <div class="rule third">
          <img src="../images/rule3.png" alt="" />
          <p class="title">活动内容</p>
        </div>
        <div class="content">
          <p>
            活动期间，新老用户加入行业交流群，即可参与社群内抽奖活动，
            奖品为实物奖品（价值80元）；中奖后分享至朋友圈，并截图联系虹助手领取。
          </p>
        </div>
        <div class="rule fourth">
          <img src="../images/rule4.png" alt="" />
          <p class="title">激活码及实物奖品发送</p>
        </div>
        <div class="deliver">
          <p class="deliver-title">
            <span>1. </span>因奖品有限，在社群抽奖活动中，用户仅限获得1次奖品，
            即用户中奖后将无法重复参与本次抽奖活动；
          </p>
          <p class="deliver-title">
            <span>2. </span
            >获得实物奖品的用户请及时联系虹助手，虹助手将与您核实地址并在取得联系后15个工作日内寄送奖品。
          </p>
        </div>
        <div class="tips">
          <p class="tips-title">注意事项</p>
          <p>
            1.
            对于通过恶意注册或其他不正当手段在本次活动中进行非法牟利、炒作、转售、获奖的用户，
            虹软视觉开放平台有权取消其获奖资格或其因参加活动所获权益；
          </p>
          <p>2. 虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。</p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { post } from "../utils/request";
export default {
  data() {
    return {
      isNewUser: false,
      friendName: "130****4567",
      randomImg: "/ucenter/api/authimage",
      veriBtn: "获取短信验证码",
      inviteCode: "",
      successFlag: false,
      showCodeTip: false,
      showPhoneTip: false,
      showInviteTips: false,
      showImgTip: false,
      isCounting: false,
      isImgCodeTrue: false,
      veriPhone: "",
      veriCode: "",
      veriImg: "",
      phoneNumber: "",
      codeNumber: "",
      imgCodeNumber: "",
    };
  },
  created() {
    this.getInviteCode();
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    if (document.location.href.indexOf("ai.arcsoft.com.cn") > 0) {
      gtag("config", "UA-7959274-33");
    } else {
      gtag("config", "UA-7959274-34");
    }
  },
  methods: {
    handleShow() {
      $(".join-group").css("display", "none");
    },
    async getInviteCode() {
      var url = window.location.href;
      var index = url.indexOf("?");
      this.inviteCode = url.slice(index + 6);
      await post("/operator/new-version/queryPhoneByLink", {
        inviteCode: this.inviteCode,
      }).then((res) => {
        if (res.data.success == true) {
          this.friendName = res.data.retObj;
        } else {
        }
      });
    },
    async linkUser() {
      await post("/ucenter/activity/bindExtension", {
        sign: this.inviteCode,
        tag: 202107,
      }).then((res) => {
        if (res.data.success == true) {
          this.successFlag = true;
        } else {
        }
      });
    },
    //用户登录
    async handleNext() {
      gtag("event", "为好友助力", {
        event_category: "邀友活动",
        event_label: "click1",
      });
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
      }
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      }
      if (this.codeNumber == "" || this.codeNumber == null) {
        this.veriCode = "请输入验证码";
        this.showCodeTip = true;
      }
      if (this.phoneNumber && !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      }
      /* 用户登录 */
      if (
        this.phoneNumber &&
        /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber) == true &&
        this.isImgCodeTrue == true
      ) {
        this.showPhoneTip = false;
        this.showCodeTip = false;
        this.showImgTip = false;
        await post("/ucenter/user/LoginForCode", {
          phone: this.phoneNumber,
          smsValidCode: this.codeNumber,
          regSource: 18,
          regDeviceType: 1,
          imgValidCode: this.imgCodeNumber,
        }).then((res) => {
          if (res.data.success == true) {
            if (res.data.retObj.firstReg !== 0) {
              this.linkUser();
            } else {
              //是老用户
              this.isNewUser = true;
              setTimeout(() => {
                this.isNewUser = false;
              }, 2000);
            }
          } else {
            this.veriCode = "验证码输入错误";
            this.showCodeTip = true;
          }
        });
      }
    },
    //切换图形验证码
    changeImgCode() {
      this.randomImg = `/ucenter/api/authimage?${Math.random()}`;
    },
    /* 发送验证码 */
    async sendCode() {
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      } else if (
        this.phoneNumber &&
        !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)
      ) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      } else {
        this.showPhoneTip = false;
      }
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
        return;
      }
      if (this.phoneNumber && /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.showPhoneTip = false;
        await post("/ucenter/API/SMSService/SendRegKeyV2?t=" + Math.random(), {
          phoneNum: this.phoneNumber,
          imageCode: this.imgCodeNumber,
          type:2
        }).then((res) => {
          if (res.data.success == false) {
            this.veriImg = "图形验证码错误";
            this.showImgTip = true;
          } else {
            this.isImgCodeTrue = true;
            this.showImgTip = false;
            this.isCounting = true;
            var time = 60;
            var countDown = setInterval(() => {
              time--;
              this.veriBtn = "重新发送" + time;
              if (time == 0) {
                this.isCounting = false;
                this.veriBtn = "获取短信验证码";
                clearInterval(countDown);
              }
            }, 1000);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  overflow: hidden;
  .banner {
    img {
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
  .banner-mobile {
    display: none;
  }
  .new-user {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    .new-user-box {
      width: 384px;
      height: 80px;
      background-color: #2202a1;
      border-radius: 16px;
      p {
        width: 288px;
        height: 18px;
        font-size: 18px;
        line-height: 18px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0 auto;
        text-align: center;
        &:first-child {
          margin-top: 15px;
        }
        &:last-child {
          margin-top: 10px;
        }
      }
    }
  }
  .join-group {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    &-box {
      position: relative;
      width: 296px;
      height: 384px;
      background-color: #2202a1;
      border-radius: 16px;
      .close-img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 24px;
        right: 23px;
        cursor: pointer;
      }
      > div {
        width: 112px;
        height: 46px;
        font-family: Source Han Sans CN;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 60px auto 16px;
      }
      > img {
        width: 197px;
        height: 197px;
        margin: 0 auto;
        display: block;
        + a {
          width: 84px;
          height: 12px;
          text-decoration: underline;
          font-size: 12px;
          line-height: 12px;
          letter-spacing: 0px;
          color: #ffffff;
          display: block;
          margin: 12px auto 0;
        }
      }
    }
  }
  .wrapper {
    width: 100%;
    height: 2770px;
    box-sizing: border-box;
    position: relative;
    background-image: linear-gradient(181deg, #2602ab 0%, #040b46 100%);
    .bg1 {
      position: absolute;
      right: -280px;
    }
    .bg2 {
      position: absolute;
      top: 1623px;
      left: -120px;
    }
    .bg3 {
      position: absolute;
      top: 2550px;
      right: -140px;
    }
    .bg4 {
      position: absolute;
      top: 3401px;
      left: -200px;
    }
    .bg5 {
      position: absolute;
      top: 3675px;
      right: -200px;
    }
    .ball1 {
      position: absolute;
      left: -125px;
      top: 464px;
      width: 248px;
      height: 248px;
    }
    .ball2 {
      position: absolute;
      top: 1377px;
      right: -99px;
      width: 347px;
      height: 347px;
    }
    .login-wrap {
      width: 100%;
    }
    .login {
      width: 1252px;
      height: 572px;
      position: relative;
      background-image: url("../images/invite/login-bg-pc.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      .title {
        height: 28px;
        position: absolute;
        font-size: 28px;
        line-height: 48px;
        letter-spacing: 0px;
        color: #ffffff;
        top: 64px;
        left: 340px;
      }
      .loginForm-box {
        display: flex;
        //   display: none;
        flex-direction: column;
        width: 488px;
        height: 273px;
        margin: 0 auto;
        padding-top: 190px;
        .img-verify-wrap,
        .phone-verify-wrap,
        .phoneNum-verify-wrap {
          position: relative;
          display: flex;
          justify-content: space-between;
        }
        .phone-number,
        .veri-code,
        .imgCodeIpt {
          width: 488px;
          height: 48px;
          line-height: 48px;
          border: none;
          outline: none;
          border-radius: 2px;
          margin-bottom: 24px;
          font-size: 24px;
          padding-left: 16px;
          box-sizing: border-box;
        }
        .phone-number::placeholder {
          font-size: 20px;
          color: #d2d2d2;
        }
        .veri-code::placeholder {
          font-size: 20px;
          color: #d2d2d2;
        }
        .imgCodeIpt::placeholder {
          font-size: 20px;
          color: #d2d2d2;
        }
        .veri-code,
        .imgCodeIpt {
          width: 280px;
        }
        .btn-message {
          width: 200px;
          height: 46px;
          line-height: 46px;
          border-radius: 2px;
          border: solid 1px #ffb758;
          font-size: 24px;
          color: #ffb758;
          cursor: pointer;
          text-align: center;
        }
        .next-btn {
          width: 488px;
          height: 56px;
          line-height: 56px;
          background: url("../images/invite/reg-next-pc.png") no-repeat center;
          background-size: 100% auto;
          letter-spacing: 2px;
          color: #ffffff;
          font-size: 24px;
          cursor: pointer;
          border-radius: 4px;
          text-align: center;
        }
        .title {
          font-size: 16px;
        }
        .desc {
          font-size: 14px;
        }
        .veri-btn,
        .veri-btn-counting,
        #img-code {
          width: 200px;
          height: 48px;
          line-height: 48px;
          cursor: pointer;
          border: solid 1px #ffb758;
          color: #ffb758;
          text-align: center;
        }
        .veriPhone,
        .veriCode,
        .veriImg {
          position: absolute;
          left: 0;
          bottom: 4px;
          color: red;
          font-size: 13px;
        }
      }
    }
    .success {
      width: 1240px;
      height: 448px;
      position: relative;
      background-image: url("../images/invite/success-bg-pc.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      .title {
        height: 28px;
        position: absolute;
        font-size: 28px;
        line-height: 48px;
        letter-spacing: 0px;
        color: #ffffff;
        top: 64px;
        left: 340px;
      }
      .successForm-box {
        width: 563px;
        height: 472px;
        margin-left: 370px;
        text-align: center;
        box-sizing: border-box;
        .info {
          width: 512px;
          height: 265px;
          font-size: 32px;
          line-height: 54px;
          letter-spacing: 0px;
          color: #ffffff;
          box-sizing: border-box;
          padding-top: 165px;
        }
        .btn {
          width: 488px;
          height: 56px;
          background-image: linear-gradient(233deg, #de54ff 0%, #ff7e7e 100%);
          border-radius: 4px;
          margin-top: 45px;
          font-size: 24px;
          line-height: 56px;
          letter-spacing: 0px;
          color: #ffffff;
          text-decoration: none;
          display: block;
          margin-left: 12px;
          + a {
            width: 80px;
            height: 16px;
            text-decoration: underline;
            font-size: 16px;
            line-height: 16px;
            letter-spacing: 0px;
            color: #ffffff;
            display: block;
            margin-top: 16px;
            margin-left: 215px;
          }
        }
      }
    }
    .three-steps {
      display: block;
      box-sizing: border-box;
      padding-top: 96px;
      .title3 {
        width: 310px;
        height: 47px;
        display: block;
        margin: 0 auto;
      }
      .three-steps-content {
        width: 822px;
        margin: 64px auto 0;
        display: flex;
        .three-steps-item {
          img {
            width: 192px;
            height: 168px;
            margin-left: 15px;
            margin-bottom: 10px;
          }
          p {
            text-align: center;
            height: 20px;
            font-size: 18px;
            line-height: 20px;
            letter-spacing: 1px;
            color: #ffffff;
            &:last-child {
              margin-top: 9px;
            }
          }
          &:not(:last-child) {
            margin-right: 90px;
          }
        }
      }
    }
    .three-steps-mobile {
      display: none;
    }
    .get-code {
      width: 492px;
      height: 60px;
      background-image: url("../images/invite/get-code.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% auto;
      margin: 64px auto 112px;
      text-align: center;
      font-size: 22px;
      line-height: 60px;
      letter-spacing: 0px;
      color: #ffffff;
      text-decoration: none;
      display: block;
    }
    .qrcode {
      width: 590px;
      margin: 0 auto;
      p {
        height: 28px;
        font-size: 28px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
      }
      .dd {
        display: block;
        height: 28px;
        font-size: 28px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
      }
      .tt {
        display: none;
      }
      img {
        display: block;
        margin: 48px auto;
      }
    }
    .activity {
      display: block;
      width: 992px;
      height: 792px;
      border-radius: 8px;
      margin: 96px auto 0;
      background-color: rgba(255, 255, 255, 0.1);
      box-sizing: border-box;
      padding-top: 66px;
      &-heading {
        height: 22px;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 4px;
        color: #ffffff;
        text-align: center;
        margin-bottom: 56px;
      }
      .rule {
        display: flex;
        align-items: center;
        margin-left: 108px;
        > img {
          width: 32px;
          height: 32px;
          margin-right: 28px;
        }
        .title {
          width: 96px;
          height: 20px;
          font-size: 20px;
          line-height: 20px;
          letter-spacing: 4px;
          color: #fed590;
          margin-right: 24px;
        }
        &.first {
          margin-top: 20px;
          p:last-child {
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #ffffff;
          }
        }
        &.second {
          margin-top: 28px;
          p:last-child {
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #ffffff;
          }
        }
        &.third {
          margin-top: 28px;
        }
        &.fourth {
          margin-top: 25px;
          p {
            width: 242px;
          }
        }
        &.fifth {
          margin-top: 50px;
          p {
            width: 120px;
          }
        }
      }
      .content {
        p {
          width: 713px;
          height: 48px;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-left: 168px;
          margin-top: 16px;
        }
      }
      .deliver {
        width: 713px;
        margin-top: 16px;
        margin-left: 168px;
        &-title {
          height: 24px;
          line-height: 26px;
          font-size: 14px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-bottom: 28px;
          > span {
            letter-spacing: 4px;
            font-size: 18px;
            color: #fed590;
          }
          &.use {
            margin-top: 28px;
          }
        }
      }
      .tips {
        width: 76px;
        height: 16px;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 3px;
        color: #ffffff;
        margin-left: 111px;
        margin-top: 62px;
        p:not(:first-child) {
          width: 713px;
          height: 60px;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-left: 64px;
        }
        p:nth-child(2) {
          margin-top: 20px;
        }
      }
    }
    .activity-mobile {
      display: none;
    }
  }
}
@media screen and (max-width: 750px) {
  .main {
    width: 100%;
    overflow: hidden;
    .new-user {
      .new-user-box {
        width: 288px;
        height: 85px;
        border-radius: 16px;
      }
    }
    .join-group-box {
      width: 288px;
    }
    .banner {
      display: none;
    }
    .banner-mobile {
      display: block;
      img {
        width: 100%;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
    .wrapper {
      width: 100%;
      height: 1890px;
      background-image: linear-gradient(181deg, #2602ab 0%, #040b46 100%);
      .bg1,
      .bg2,
      .bg3,
      .bg4,
      .bg5,
      .ball1,
      .ball2 {
        display: none;
      }
      .login {
        width: 315px;
        height: 250px;
        background-image: url("../images/invite/login-bg-mobile.png");
        .title {
          position: absolute;
          height: 12px;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 12px;
          letter-spacing: 0px;
          color: #ffffff;
          top: 22px;
          left: 30px;
        }
        .loginForm-box {
          width: 244px;
          height: 154px;
          padding-top: 60px;
          .phone-number,
          .veri-code,
          .imgCodeIpt {
            width: 244px;
            height: 32px;
            line-height: 32px;
            border-radius: 1px;
            font-size: 12px;
            padding-left: 8px;
            margin-bottom: 17px;
          }

          .phone-number {
            height: 28px;
            line-height: 28px;
          }
          .phone-number::placeholder {
            font-size: 12px;
            color: #d2d2d2;
          }
          .veri-code,
          .imgCodeIpt {
            width: 140px;
          }
          .veri-code::placeholder {
            font-size: 12px;
            color: #d2d2d2;
          }
          .imgCodeIpt::placeholder {
            font-size: 12px;
            color: #d2d2d2;
          }
          .veri-btn,
          .veri-btn-counting,
          .btn-message,
          #img-code {
            width: 100px;
            height: 32px;
            line-height: 32px;
            font-size: 12px;
          }
          .btn-message {
            height: 30px;
            line-height: 30px;
            border-radius: 1px;
            font-size: 12px;
            color: #fff258;
            border: solid 1px #fff258;
          }
          .next-btn {
            width: 244px;
            height: 29px;
            line-height: 29px;
            font-size: 11px;
            letter-spacing: 1px;
          }
          .veriPhone,
          .veriCode,
          .veriImg {
            position: absolute;
            left: 0;
            bottom: 1px;
            color: red;
            font-size: 7px;
          }
        }
      }
      .success {
        width: 288px;
        height: 193px;
        background-image: url("../images/invite/success-bg-mobile.png");
        .title {
          position: absolute;
          height: 12px;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 12px;
          letter-spacing: 0px;
          color: #ffffff;
          top: 22px;
          left: 12px;
        }
        .successForm-box {
          width: 240px;
          margin-left: 25px;
          text-align: center;
          box-sizing: border-box;
          .info {
            box-sizing: border-box;
            padding-top: 61px;
            width: 224px;
            height: 38px;
            font-size: 14px;
            line-height: 24px;
            letter-spacing: 0px;
            color: #ffffff;
            margin: 0 auto;
          }
          .btn {
            width: 240px;
            height: 28px;
            background-image: linear-gradient(233deg, #de54ff 0%, #ff7e7e 100%);
            border-radius: 4px;
            margin-top: 60px;
            font-size: 12px;
            line-height: 28px;
            letter-spacing: 0px;
            color: #ffffff;
            text-decoration: none;
            display: block;
            margin: 60px auto 0;
            + a {
              width: 60px;
              height: 12px;
              text-decoration: underline;
              font-size: 12px;
              line-height: 20px;
              letter-spacing: 0px;
              color: #ffffff;
              display: block;
              margin-top: 8px;
              margin-left: 91px;
            }
          }
        }
      }
      .three-steps {
        display: none;
      }
      .three-steps-mobile {
        display: block;
        width: 100%;
        margin-top: 48px;
        .title {
          width: 144px;
          margin: 0 auto;
          p:first-child {
            width: 144px;
            height: 16px;
            font-size: 16px;
            line-height: 16px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-bottom: 9px;
          }
          p:not(:first-child) {
            width: 144px;
            height: 1px;
            background-color: #ffb758;
            border-radius: 8px;
          }
          p:last-child {
            margin-top: 2px;
          }
        }
        > img {
          display: block;
          margin: 0 auto 36px;
        }
        &-content {
          margin: 36px auto 0;
          ul {
            list-style: none;
            li {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 25px;
              img {
                width: 80px;
                height: 87px;
              }
              p {
                width: 125px;
                height: 49px;
                font-size: 14px;
                line-height: 24px;
                letter-spacing: 1px;
                color: #ffffff;
                margin-top: -10px;
                margin-left: 24px;
              }
            }
          }
        }
      }
      .get-code {
        width: 226px;
        height: 34px;
        background-image: url("../images/invite/get-code-mobile.png");
        margin: 25px auto 40px;
        font-size: 12px;
        line-height: 34px;
        letter-spacing: 0px;
        color: #ffffff;
        display: block;
      }
      .qrcode {
        width: 224px;
        p {
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          letter-spacing: 0px;
          color: #ffffff;
        }
        .dd {
          display: none;
        }
        .tt {
          display: block;
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          letter-spacing: 0px;
          color: #ffffff;
          p:last-child {
            margin-top: 7px;
          }
        }
        img {
          width: 168px;
          height: 168px;
          margin: 24px auto;
        }
      }
      .activity {
        display: none;
      }
      .activity-mobile {
        display: block;
        width: 264px;
        height: 725px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        margin: 80px auto 0;
        padding-top: 14px;
        box-sizing: border-box;
        &-heading {
          width: 77px;
          height: 16px;
          font-size: 16px;
          line-height: 16px;
          letter-spacing: 3px;
          color: #ffffff;
          margin: 0 auto;
        }
        .rule {
          display: flex;
          align-items: center;
          margin-left: 16px;
          > img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            margin-top: -2px;
          }
          .title {
            width: 68px;
            height: 14px;
            font-size: 14px;
            line-height: 14px;
            letter-spacing: 3px;
            color: #fed590;
          }
          &.first {
            margin-top: 24px;
            + p {
              height: 14px;
              font-size: 12px;
              line-height: 14px;
              letter-spacing: 2px;
              color: #ffffff;
              margin-left: 42px;
              margin-top: 8px;
            }
          }
          &.second {
            margin-top: 19px;
            + p {
              height: 14px;
              font-size: 12px;
              line-height: 14px;
              letter-spacing: 2px;
              color: #ffffff;
              margin-left: 42px;
              margin-top: 8px;
            }
          }
          &.third {
            margin-top: 19px;
          }
          &.fourth {
            margin-top: 75px;
            p {
              width: 242px;
            }
          }
          &.fifth {
            margin-top: 60px;
            p {
              width: 120px;
            }
          }
        }
        .content {
          width: 222px;
          margin-left: 16px;
          > p {
            height: 36px;
            line-height: 18px;
            font-size: 12px;
            letter-spacing: 2px;
            color: #ffffff;
            margin-bottom: 5px;
            margin-top: 16px;
          }
          &-title {
            height: 14px;
            line-height: 14px;
            margin-top: 19px;
            font-size: 12px;
            letter-spacing: 2px;
            color: #ffffff;
            > span {
              font-size: 14px;
              letter-spacing: 3px;
              color: #fed590;
            }
            &.second {
              margin-top: 35px;
              + p {
                margin-top: -14px;
              }
            }
          }
        }
        .deliver {
          margin-top: 18px;
          margin-left: 16px;
          padding-right: 26px;
          &-title {
            height: 95px;
            line-height: 18px;
            font-size: 12px;
            letter-spacing: 2px;
            color: #ffffff;
            > span {
              letter-spacing: 3px;
              font-size: 14px;
              color: #fed590;
            }
            &.use {
              margin-top: 20px;
              + p {
                margin-top: 0px;
              }
            }
            &:nth-child(2) {
              margin-top: -18px;
            }
            &.md {
              margin-top: -16px;
            }
          }
        }
        .tips {
          width: 76px;
          height: 14px;
          font-size: 14px;
          line-height: 14px;
          letter-spacing: 3px;
          color: #ffffff;
          margin-left: 16px;
          padding-right: 32px;
          padding-bottom: 14px;
          p:not(:first-child) {
            width: 220px;
            height: 18px;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 2px;
            color: #ffffff;
          }
          p:nth-child(2) {
            margin-top: 15px;
          }
          p:nth-child(3) {
            margin-top: 77px;
          }
          p:last-child {
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>